<div
  class="collection-item"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_rounded]="loading"
  [class.collection-item_archive]="item?.status === 2"
>
  <div class="collection-item__banner-wrapper">
    <lp-category-cell [category]="banner" [readonly]="true" [withBackground]="true"></lp-category-cell>
  </div>

  <div class="collection-item__info">
    <div class="product-name text_bold">
      {{ item?.title }}
    </div>

    <div *ngIf="item?.validTill">
      {{ 'components.lpCollectionList.labels.validTill' | translate: { value: item?.validTill | date: 'dd.MM.yyyy' } }}
    </div>

    <div *ngIf="item?.pushSendOn">
      {{
        'components.lpCollectionList.labels.pushSendOn '
          | translate: { value: item?.pushSendOn | date: 'dd.MM.yyyy HH:mm' }
      }}
    </div>

    <div class="products-count">
      {{ 'components.lpCollectionList.labels.productsCount' | translate: { value: item?.productsCount } }}
    </div>
  </div>
</div>
